<template>
  <div class="edit-container">
    <el-dialog
      :visible="isShow"
      title="编辑申请发货单"
      width="1000px"
      class="partShipment"
      @close="handelClose"
    >
      <p>
        产品信息<span style="color: red">&nbsp;&nbsp;注：货运方式为供应商直发的产品预计在提交申请三天后发货;</span>
      </p>
      <el-button type="primary" :disabled="!selectList.length" @click="handleRemove">
        删除勾选的产品
      </el-button>
      <el-table
        ref="tableRef"
        v-loading="loading"
        scrollbar-always-on
        :data="baseInfo.partialInvoiceProductList"
        border
        style="width: 100%;margin-top:10px;margin-bottom:10px"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" align="left" width="50" fixed="left" />
        <el-table-column prop="contractNum" label="合同号" align="left" width="150" />
        <el-table-column prop="materialNumber" label="物品代码" align="left" width="150" />
        <el-table-column prop="productName" label="物品名称" align="left" width="230" />
        <el-table-column prop="productNum" label="数量" align="left" width="70" />
        <el-table-column prop="productPriceSigle" label="实际结算单价" align="right" header-align="left" width="200" />
        <el-table-column prop="settlementAmount" label="实际结算金额" align="right" header-align="left" width="200" />
        <el-table-column prop="expectedDeliveryDate" label="客户期望发货日" align="left" width="150" />
        <el-table-column prop="agreedDate" label="约定交付日期" align="left" width="150" />
      </el-table>

      <div class="advanceMakeDeatail">
        <div class="baseInfoForm">
          <h3>原信息</h3>
          <div class="rj-row">
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  收货地址：
                </div>
                <div class="rj-baseinfo__item">
                  {{ baseInfo.primaryReceiptAddress }}
                </div>
              </div>
            </div>
          </div>

          <div class="rj-row">
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  运输方式：
                </div>
                <div class="rj-baseinfo__item">
                  {{ baseInfo.primaryModelOfShipping }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  承运商：
                </div>
                <div class="rj-baseinfo__item">
                  {{ baseInfo.primaryCarrier }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h3>变更后信息</h3>
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              <i class="require-style">*</i>
              变更后收货地址：
            </div>
            <div class="rj-baseinfo__item" @click="handleSelectAddress">
              <span v-if="formData.address" style="cursor: pointer;">{{ formData.address }}</span>
              <span v-else class="address-style">选择地址</span>
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              <i class="require-style">*</i>
              变更后运输方式：
            </div>
            <div class="rj-baseinfo__item">
              <el-radio-group v-model="formData.modeOfShipping">
                <el-radio
                  v-for="(item, index) in modeOfShippingList"
                  :key="index"
                  :label="item.label"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              <i class="require-style">*</i>
              变更后承运商：
            </div>
            <div class="rj-baseinfo__item">
              <el-select v-model="formData.carrier" placeholder="请选择活动区域">
                <el-option
                  v-for="(item, index) in carrierList"
                  :key="index"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              <i class="require-style">*</i>
              是否需要唛头：
            </div>
            <div class="rj-baseinfo__item">
              <el-radio-group v-model="formData.markType">
                <el-radio
                  v-for="(item, index) in makeList"
                  :key="index"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              <i class="require-style">*</i>
              授权邮箱：
            </div>
            <div class="rj-baseinfo__item">
              <el-input v-model="formData.authorizationEmail" placeholder="请输入授权邮箱" />
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-1">
          <p>
            <i class="require-style">*</i>
            收货回执及到货验收要求：
          </p>
          <el-input
            v-model="formData.receiptArrivalAcceptanceRequirements"
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 6}"
            placeholder="请输入收货回执及到货验收要求"
          />
        </div>
      </div>

      <div class="rj-row upload-row">
        <span>回执附件：</span>
        <el-upload
          action=""
          multiple
          :http-request="uploadaction"
          name="fileName"
          :show-file-list="false"
          :file-list="fileList"
          class="upload-style"
        >
          <el-button type="primary">
            上传附件
          </el-button>
        </el-upload>
        <div class="file-style">
          <ul v-if="fileList.length">
            <li v-for="(item, index) in fileList" :key="index">
              <span>{{ item.fileName || item.name }}</span>
              <i class="el-icon-close" @click="clearFile(index)" />
            </li>
          </ul>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-1">
          <p>
            <i class="require-style">*</i>
            发货备注说明：
          </p>
          <el-input
            v-model="formData.deliverRemark"
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 6}"
            placeholder="请输入发货备注说明"
          />
        </div>
      </div>

      <div class="rj-row">
        <p>备注：</p>
        <el-input
          v-model="formData.remark"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 6}"
          placeholder="请输入备注"
        />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="handelSubmit">提交并返回列表</el-button>
        <el-button type="default" @click="handelDiscard">废弃申请</el-button>
        <el-button type="primary" @click="handelSubmit('pay')">提交并前往付款</el-button>
      </span>
    </el-dialog>
    <addressBox
      :prop-open.sync="isShowAddress"
      @chooseAddress="changeAddress"
      @ChangeDatas="changeDatas"
    />
  </div>
</template>
<script type="es6">
import AxiosApi from '@/API/fileAxios';
import addressBox from '@/views/address/index.vue';
import {
  agentGetPartialInvoiceDetail,
  attachmentGetToken,
  getReceiptAddressInfoModel,
  businessConfirmApplyPartialShipment,
  checkSplitAndFreightPayType,
  partialInvoiceInvalid
} from '@/API';
import { MathAdd } from '@/libs/util';
import { checkPartialShipmentCompliance } from '@/libs/partialShipmentCompliance';
export default {
  props: {},

  components: {
    addressBox
  },

  data () {
    return {
      currentItem: {},
      isShow: false,
      isShowAddress: false,
      selectList: [],
      originAddress: {}, // 原地址源数据
      formData: {
        markType: false
      }, // 提交的数据对象
      loading: false,
      baseInfo: {}, // 所有信息
      fileList: [],
      modeOfShippingList: [ // 变更后运输方式
        { label: '陆运' },
        { label: '航空' }
      ],
      carrierList: [ // 变更后承运商
        { label: '默认物流' },
        { label: '顺丰' }
      ],
      makeList: [
        { value: true, label: '是' },
        { value: false, label: '否' }
      ]
    };
  },

  methods: {
    initData (row) {
      this.loading = true;
      agentGetPartialInvoiceDetail({ id: row.id }).then(res => {
        const { data, status } = res.data;
        if (status === '200') {
          this.loading = false;
          this.baseInfo = data;
          this.fileList = data.reversedInvoiceVO;
          this.$set(this.formData, 'address', `${data.receiptAddress.province}${data.receiptAddress.city}${data.receiptAddress.county}`);
          this.$set(this.formData, 'modeOfShipping', data.partialInvoiceDetail.modeOfShipping);
          this.$set(this.formData, 'carrier', data.partialInvoiceDetail.carrier);
          this.$set(this.formData, 'markType', data.partialInvoiceDetail.markType);
          this.$set(this.formData, 'authorizationEmail', data.partialInvoiceDetail.authorizationEmail);
          this.$set(this.formData, 'receiptArrivalAcceptanceRequirements', data.partialInvoiceDetail.receiptArrivalAcceptanceRequirements);
          this.$set(this.formData, 'deliverRemark', data.partialInvoiceDetail.deliverRemark);
          this.$set(this.formData, 'remark', data.partialInvoiceDetail.remark);
          this.loading = false;
        }
      });
    },
    async handelSubmit (type) {
      const { modeOfShipping, carrier, authorizationEmail, receiptArrivalAcceptanceRequirements } = this.formData;
      if (!(modeOfShipping && carrier && authorizationEmail && receiptArrivalAcceptanceRequirements)) {
        this.$message.error('请检查必填项');
        return;
      }
      let params = {
        partialId: this.currentItem.id, // 分批发货id
        masterContractId: this.baseInfo.partialInvoiceInfo.masterContractId, // 主（原）合同主键
        masterContractNum: this.baseInfo.partialInvoiceInfo.masterContractNum, // 合同号
        masterProjectName: this.baseInfo.partialInvoiceInfo.masterProjectName, // 项目名称
        partialInvoiceFile: this.fileList,
        partialInvoiceProductList: this.baseInfo.partialInvoiceProductList, // 申请的部分发货产品列表
        detail: {
          ...this.formData,
          amountSum: this.baseInfo.partialInvoiceDetail.amountSum || 0,
          id: this.baseInfo.partialInvoiceDetail.id,
          partialId: this.currentItem.id,
          partialAddressId: this.originAddress.id, // 发货单收货地址id
          receiptAddressId: this.baseInfo.receiptAddress.id // 主（原）收货地址id
        }
      };
      delete params.detail.address;
      try {
        const canSubmit = await checkPartialShipmentCompliance({
          businessScene: 'DOMESTIC_PARTIAL_SHIPMENT_BUSINESS_SUBMIT',
          originalBizId: params.partialId,
          contractInfo: this.baseInfo.partialInvoiceInfo || {},
          address: this.baseInfo.receiptAddress,
          products: params.partialInvoiceProductList,
          projectName: params.masterProjectName
        });
        if (!canSubmit) return;
      } catch (error) {
        this.$message.error(error.message || '出口合规检测失败');
        return;
      }
      businessConfirmApplyPartialShipment(params).then(res => {
        const { status } = res.data;
        if (status === '200') {
          this.formData = {};
          this.$message.success('操作成功');
          this.handelClose();
          this.$emit('init-data');
          if (type === 'pay') {
            // 去付款
            this.$store.commit('pagesTemporary/SETChiefContractListTabActive', '9');
            this.$router.push({
              name: 'ChiefContractList'
            });
            this.$router.push({ name: 'BatchBase',
              query: {
                id: this.currentItem.id,
                masterContractNum: this.baseInfo.partialInvoiceInfo.masterContractNum,
                deliveryNum: this.currentItem.deliveryNum
              } });
          }
        }
      });
    },

    handelDiscard () {
      checkSplitAndFreightPayType({
        id: this.currentItem.id
      }).then(res => {
        const { status } = res.data;
        if (status === '200') {
          partialInvoiceInvalid({
            id: this.currentItem.id
          }).then(res => {
            const { status } = res.data;
            if (status === '200') {
              this.$message.success('操作成功');
              this.handelClose();
              this.$emit('init-data');
            }
          });
        }
      });
    },

    // 选择地址
    handleSelectAddress () {
      this.isShowAddress = true;
    },

    changeAddress (val) {
      this.originAddress = val;
      this.formData.address = `${val.province}${val.city}${val.county}`;
      this.isShowAddress = false;
      console.log(val, 'val');
    },

    changeDatas () {
      // 地址选择 地址源地址列表发生变化，需要用当前地址id 重新查询地址信息
      if (this.originAddress.id) {
        getReceiptAddressInfoModel(this.address.id).then((res) => {
          const { data, status } = res.data;
          if (status === '200') {
            if (!data.isDelete) {
              this.formData.address = `${data.province}${data.city}${data.county}`;
            } else {
              this.address = {};
            }
          }
        });
      }
    },

    uploadaction (upload) {
      const form = new FormData(); // 创建form对象
      form.append('files', upload.file);
      const myfile = {
        enclosureName: upload.file.name,
        loading: true,
        percentage: 0
      };

      AxiosApi.post(this.uploadUrl + `?Token=${this.token}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          myfile.percentage = (progressEvent.loaded / progressEvent.total * 100 | 0);
        }
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.fileList.push({
            fileName: json.data[0].FullName,
            fileToken: json.data[0].FID
          });
          myfile.loading = false;
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
        } else {
          myfile.loading = false;
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
      }).catch(() => {
        myfile.loading = false;
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
      });
    },

    clearFile (i) {
      this.fileList.splice(i, 1);
    },

    handleSelectionChange (val) {
      this.selectList = val.map(i => i.id);
    },

    // 删除勾选的产品
    handleRemove () {
      this.$confirm('请确认是否删除该产品', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.baseInfo.partialInvoiceProductList = this.baseInfo.partialInvoiceProductList.filter(i => !this.selectList.includes(i.id));
      }).catch(() => {
        this.$refs.tableRef.clearSelection();
      });
    },

    // 合计行的计算
    getSummaries (param) {
      const { columns } = param;
      const sums = ['合计'];
      columns.forEach((column, index) => {
        if (column.label === '数量') {
          sums[index] = this.productNum(param.data);
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.productNum(param.data);
        }
      });
      return sums || 0;
    },

    // 实际结算金额总计
    productNum (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.productNum);
      });
      // cont = Number(cont).toFixed(2);
      return cont || 0;
    },

    initToken () {
      attachmentGetToken().then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      });
    },

    openDialog (row) {
      this.currentItem = row;
      this.initData(row);
      this.initToken();
      this.isShow = true;
    },

    handelClose () {
      this.baseInfo = {};
      this.fileList = [];
      this.formData = {};
      this.currentItem = {};
      this.isShow = false;
    }
  }
};
</script>

<style>
.el-scrollbar__bar.is-vertical {
  opacity: 1;
}
.edit-container .el-dialog__body {
  padding: 10px 20px;
}
</style>
<style lang="scss" scoped>
.require-style {
  color: red;
}
.upload-row {
  .upload-style {
    display: inline-block;
    margin: 5px 10px 0 10px;
  }
}
.file-style {
  margin: 8px 0 0 80px;
  ul {
    width: 100%;
    list-style: none;
    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #3f9ef5;
      line-height: 22px;
      cursor: pointer;
    }
  }
}
.partShipment p{
  margin: 10px 0 ;
}
.partShipment p span{
  display:inline-block;
  margin-right: 10px;
}
.address-style {
  color: #409EFF;
  cursor: pointer;
}
</style>
